import React, { useState } from "react"
import Modal from './../index'
import FormGroupInline from "../../Form/FormGroupInline"
import FormGroup from "../../Form/FormGroup"
import Input from "../../Form/Input"
import Button from "../../Form/Button"
import { MdChatBubbleOutline } from "react-icons/md"

const ModalNewFlow = ({ onSubmit = () => { }, closeModal = () => { } }) => {
    const [flow, setFlow] = useState({})

    const handleChangeValue = (name, value) => {
        setFlow(previousValue => { return { ...previousValue, [name]: value } })
    }

    const handleCancel = (e) => {
        e.preventDefault()
        closeModal()
    }

    const handleSave = (e) => {
        e?.preventDefault()
        onSubmit(flow)
    }

    return (
        <Modal
            icon={<MdChatBubbleOutline />}
            title={"Cadastro de novo fluxo"}
            description={"Preencha os campos abaixo e clique em salvar"}
            closeModal={closeModal}
        >
            <form onSubmit={handleSave}>
                <FormGroupInline>
                    <FormGroup labelText="Nome">
                        <Input type="text" placeholder="Nome do fluxo" value={flow.name ?? ""} onChange={(e) => handleChangeValue("name", e.target.value)} />
                    </FormGroup>

                </FormGroupInline>
                <FormGroupInline>
                    <Button variant='primary' type="submit">Salvar</Button>
                    <Button variant='secondary' onClick={handleCancel}>Cancelar</Button>
                </FormGroupInline>
            </form>
        </Modal>
    )
}

export default ModalNewFlow
